module.exports = __webpack_public_path__ + "static/media/times-circle-o.1e6c4a40.png";